var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSoup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.99967H14C14 8.16867 13.988 8.33467 13.975 8.49967H2.025C2.011 8.33467 2 8.16867 2 7.99967H1C1 10.7467 2.595 13.1227 4.903 14.2677V14.9997H11V14.3147C13.361 13.1887 15 10.7847 15 7.99967ZM8 13.9997C5.21 13.9997 2.866 12.0837 2.197 9.49967H13.803C13.134 12.0837 10.79 13.9997 8 13.9997ZM7.655 7.67267C6.236 6.25367 6.891 4.80867 7.436 4.24267C8.512 3.16667 7.74 2.30267 7.648 2.20667L8.369 1.51367C8.914 2.07867 9.569 3.52467 8.15 4.94367C8.012 5.09167 7.33 5.93367 8.362 6.96567L7.655 7.67267ZM4.655 7.67267C3.236 6.25367 3.891 4.80867 4.436 4.24267C5.512 3.16667 4.74 2.30267 4.648 2.20667L5.369 1.51367C5.914 2.07867 6.569 3.52467 5.15 4.94367C5.012 5.09167 4.33 5.93367 5.362 6.96567L4.655 7.67267ZM10.655 7.67267C9.236 6.25367 9.891 4.80867 10.436 4.24267C11.512 3.16667 10.74 2.30267 10.648 2.20667L11.369 1.51367C11.914 2.07867 12.569 3.52467 11.15 4.94367C11.012 5.09167 10.33 5.93367 11.362 6.96567L10.655 7.67267Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSoup);
export default __webpack_public_path__ + "static/media/ico_soup.66c0baa2cb64237058fb08f7a1877d38.svg";
export { ForwardRef as ReactComponent };